module.exports = __webpack_public_path__ + "assets/images/test/sample-ageing-2-desktop.png?v=84681d74";